export const startAutocomplete = (editor, args) => editor.execCommand("startAutocomplete", args);
